import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "seq-stat-tile" }
const _hoisted_2 = { class: "svg-icon svg-icon-2 svg-icon-white" }
const _hoisted_3 = { class: "seq-stat-tile__label" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "seq-stat-tile__value me-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: ["seq-stat-tile__icon", _ctx.variant === 'green' ? 'seq-stat-tile__icon--green' : 'seq-stat-tile__icon--blue']
    }, [
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_inline_svg, { src: _ctx.icon }, null, 8, ["src"])
      ])
    ], 2),
    _createVNode("div", null, [
      _createVNode("div", _hoisted_3, _toDisplayString(_ctx.label), 1),
      _createVNode("div", _hoisted_4, [
        _createVNode("span", _hoisted_5, _toDisplayString(_ctx.currencySymbol) + _toDisplayString(_ctx.currencySymbol ? ' ' : '') + _toDisplayString(_ctx.formattedValue), 1),
        (_ctx.trend)
          ? (_openBlock(), _createBlock("span", {
              key: 0,
              class: [_ctx.trendUp ? 'seq-trend-up' : 'seq-trend-down', "fs-8"]
            }, _toDisplayString(_ctx.trend), 3))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}